module.exports = __webpack_public_path__ + "static/media/no.27a9baad.svg";